module.exports = __webpack_public_path__ + "img/start-network-logo.89fae985.png";